import { render, staticRenderFns } from "./SerieNumeroFormDevolucionBodega.vue?vue&type=template&id=7501bffe&scoped=true&"
import script from "./SerieNumeroFormDevolucionBodega.vue?vue&type=script&lang=ts&"
export * from "./SerieNumeroFormDevolucionBodega.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7501bffe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7501bffe', component.options)
    } else {
      api.reload('7501bffe', component.options)
    }
    module.hot.accept("./SerieNumeroFormDevolucionBodega.vue?vue&type=template&id=7501bffe&scoped=true&", function () {
      api.rerender('7501bffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/EquiposEnTerreno/SerieNumeroFormDevolucionBodega.vue"
export default component.exports